import Axios from "axios";
const baseURL = process.env.BARRAMUNDI;
export default {
    async getRoles() {
        const res = await Axios.get(`${baseURL}/actor/roles`);
        if (res && res.data && res.data.response) {
            return res.data.response.resources;
        }
        return null;
    },
    async getModules() {
        const res = await Axios.get(`${baseURL}/account/permissions`, {
            params: {
                group_by: "module"
            }
        });
        if (res && res.data && res.data.response) {
            return res.data.response.resource;
        }
        return null;
    },
    /**
     * @param {String} roleId
     * @param {Array} modules
     * @returns
     */
    async getPermissionsByRoleAndModules(roleId, modules) {
        return Axios.get(`${baseURL}/account/permissions`, {
            params: {
                module: `[${modules.join(",")}]`,
                role_id: roleId
            }
        }).then(res => {
            if (res && res.data && res.data.response) {
                return res.data.response.resource;
            }
            return null;
        });
    },
     /**
     * @param {String} key
     * @param {String} role_id
     * @param {Number} access //NOTE: either 1 or 0
     * @returns
     */
     async createPermission(key, role_id, access) {
        return Axios.post(`${baseURL}/account/permissions`, {
            key,
            role_id,
            access
        }).then(res => {
            if (res && res.data && res.data.response) {
                return res.data.response.resource;
            }
            return null;
        });
    },
    /**
     * @param {Number} permission_id
     * @param {Number} access //NOTE: either 1 or 0
     * @returns
     */
    async updatePermission(permission_id, access) {
        return Axios.put(`${baseURL}/account/permissions/${permission_id}`, {
            access
        }).then(res => {
            if (res && res.data && res.data.response) {
                return res.data.response.resource;
            }
            return null;
        });
    }
};
